import fetchServer from "../fetchServer";

const BASE_URL = "/payment/v1/intraverseBankAccount";

async function request({ method, url, data }) {
  let result = {
    return: 0,
    msg: "Something went wrong!",
  };

  await fetchServer({ method, url, data })
    .then((res) => {
      if (res?.data && !res?.data?.error) {
        result = {
          return: 1,
          msg: "Successful",
          data: res?.data?.data,
          meta: res?.data?.meta,
        };
      } else if (res?.data?.error) {
        result.msg = res.data.error;
      } else if (res?.data?.message) {
        result.msg = res.data.message;
      }
    })
    .catch(() => {
      console.log("Network Error!");
    });

  return result;
}

function buildQuery(params = {}) {
  const allowed = [
    "limit",
    "offset",
    "searchBy",
    "keyword",
    "filterBy",
    "filterValue",
  ];

  const query = new URLSearchParams();
  allowed.forEach((key) => {
    const value = params?.[key];
    if (value !== undefined && value !== null && value !== "") {
      query.set(key, value);
    }
  });

  const qs = query.toString();
  return qs ? `?${qs}` : "";
}

const intraverseBankAccountsApi = {
  /** GET /payment/v1/intraverseBankAccount */
  getAccounts: async (params = {}) => {
    return request({
      method: "GET",
      url: `${BASE_URL}${buildQuery(params)}`,
    });
  },

  /** POST /payment/v1/intraverseBankAccount */
  create: async (data) => {
    return request({
      method: "POST",
      url: BASE_URL,
      data,
    });
  },

  /** GET /payment/v1/intraverseBankAccount/:intraverseBankAccountId */
  getById: async (intraverseBankAccountId) => {
    return request({
      method: "GET",
      url: `${BASE_URL}/${intraverseBankAccountId}`,
    });
  },

  /** PATCH /payment/v1/intraverseBankAccount/:intraverseBankAccountId */
  update: async (intraverseBankAccountId, data) => {
    return request({
      method: "PATCH",
      url: `${BASE_URL}/${intraverseBankAccountId}`,
      data,
    });
  },

  /** DELETE /payment/v1/intraverseBankAccount/:intraverseBankAccountId */
  delete: async (intraverseBankAccountId) => {
    return request({
      method: "DELETE",
      url: `${BASE_URL}/${intraverseBankAccountId}`,
    });
  },
};

export default intraverseBankAccountsApi;
